class ConfirmacaoModal {
  constructor() {
    this.modal = null;
    this.overlay = null;
    this.closeBtn = null;
    this.cancelarBtn = null;
    this.confirmarBtn = null;
    this.corSelecionadaEl = null;
    this.tamanhoSelecionadoEl = null;
    this.formOriginal = null;
    this.submitBtnOriginal = null;
    this.init();
  }

  init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.setup(), { once: true });
    } else {
      this.setup();
    }
  }

  setup() {
    this.modal = document.getElementById('confirmacaoModal');
    this.overlay = this.modal?.querySelector('.confirmacao-modal__overlay');
    this.closeBtn = this.modal?.querySelector('.confirmacao-modal__close');
    this.cancelarBtn = document.getElementById('btnCancelarModal');
    this.confirmarBtn = document.getElementById('btnConfirmarModal');
    this.corSelecionadaEl = document.getElementById('modalCorSelecionada');
    this.tamanhoSelecionadoEl = document.getElementById('modalTamanhoSelecionado');

    if (!this.modal) return;

    this.setupBuyButtons();
    this.setupModalEvents();
    this.setupVariantEvents();
    this.setupMutationObserver();
  }

  setupBuyButtons() {
    const selectors = [
      'button[type="submit"][name="add"]',
      '.product-form__submit',
      '.product_submit_button',
      '.essential-preorder-container-active button',
      '[class*="preorder"] button',
      '.preorder-btn',
    ];

    document.querySelectorAll(selectors.join(',')).forEach((button) => {
      if (button.dataset.modalProcessed === 'true') return;
      button.dataset.modalProcessed = 'true';
      button.addEventListener('click', (event) => this.handleBuyClick(event));
    });
  }

  setupModalEvents() {
    this.closeBtn?.addEventListener('click', () => this.hideModal());
    this.cancelarBtn?.addEventListener('click', () => this.hideModal());
    this.overlay?.addEventListener('click', () => this.hideModal());
    this.confirmarBtn?.addEventListener('click', () => this.confirmarCompra());

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && this.modal?.classList.contains('show')) this.hideModal();
    });
  }

  setupVariantEvents() {
    document.addEventListener('variant:update', (event) => {
      if (this.modal?.classList.contains('show')) this.updateVariantInfo(event.detail?.variant);
    });
  }

  setupMutationObserver() {
    new MutationObserver((mutations) => {
      if (mutations.some((mutation) => mutation.type === 'childList' && mutation.addedNodes.length)) {
        this.setupBuyButtons();
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  handleBuyClick(event) {
    const isPreorderButton = event.currentTarget.matches('.preorder-btn, .essential-preorder-container-active button, [class*="preorder"] button');
    const form = event.currentTarget.closest('form') || (isPreorderButton ? this.getVisibleProductForm() : null);
    if (!form || !this.isAvailable(form)) return;

    event.preventDefault();
    this.formOriginal = form;
    this.submitBtnOriginal = event.currentTarget;
    this.showModal();
  }

  getVisibleProductForm() {
    const forms = [...document.querySelectorAll('form[data-type="add-to-cart-form"]')];
    return forms.find((form) => form.closest('.pdp-mobile-info') && this.isVisible(form))
      || forms.find((form) => !form.closest('.pdp-mobile-info') && this.isVisible(form))
      || forms[0]
      || null;
  }

  isVisible(element) {
    return element.getClientRects().length > 0 && getComputedStyle(element).visibility !== 'hidden';
  }

  isAvailable(form) {
    const variant = this.getVariantById(form.querySelector('input[name="id"]')?.value);
    return !variant || variant.available !== false;
  }

  getVariantById(variantId) {
    if (!variantId) return null;
    const variants = window.product?.variants || this.getProductData()?.variants || this.getVariantData();
    return variants?.find((variant) => String(variant.id) === String(variantId)) || null;
  }

  getProductData() {
    const json = document.querySelector('[data-product-json]');
    try {
      return json ? JSON.parse(json.textContent) : null;
    } catch (_) {
      return null;
    }
  }

  getVariantData(form = this.formOriginal) {
    const formId = form?.id;
    const pickers = [...document.querySelectorAll('variant-radios-detail, variant-group-detail')];
    const picker = pickers.find((element) => formId && element.querySelector(`input[form="${formId}"]`)) || pickers[0];
    const json = picker?.querySelector('script[type="application/json"]');

    try {
      return json ? JSON.parse(json.textContent) : null;
    } catch (_) {
      return null;
    }
  }

  updateVariantInfo(eventVariant) {
    const form = this.formOriginal || this.getVisibleProductForm();
    const variant = eventVariant || this.getVariantById(form?.querySelector('input[name="id"]')?.value);
    const options = variant?.options || [];
    const productOptionNames = this.getProductData()?.options || [];
    let values = this.getSelectedOptionValues(form, options, productOptionNames);
    if (values.length === 0 && options.length) {
      values = options.map((value, index) => ({
        name: productOptionNames[index] || '',
        value,
        index,
      }));
    }

    let cor = '-';
    let tamanho = '-';
    values.forEach(({ name, value, index }) => {
      const optionName = name.toLowerCase();
      if (optionName.includes('cor') || optionName.includes('color')) cor = value;
      if (optionName.includes('tamanho') || optionName.includes('size') || optionName.includes('tam')) tamanho = value;

      // O nome do campo é a fonte principal; a variante é um fallback para temas com nomes incomuns.
      if (cor === '-' && this.isColorValue(value)) cor = value;
      if (tamanho === '-' && this.isSizeValue(value)) tamanho = value;
      if (options[index]) {
        if (cor === '-' && this.isColorValue(options[index])) cor = options[index];
        if (tamanho === '-' && this.isSizeValue(options[index])) tamanho = options[index];
      }
    });

    this.corSelecionadaEl.textContent = cor;
    this.tamanhoSelecionadoEl.textContent = tamanho;
  }

  getSelectedOptionValues(form, variantOptions = [], productOptionNames = []) {
    if (!form?.id) return [];
    const groups = new Map();
    document.querySelectorAll(`input[type="radio"][form="${form.id}"]`).forEach((input) => {
      if (!groups.has(input.name)) groups.set(input.name, []);
      groups.get(input.name).push(input);
    });

    // Alguns apps removem o atributo `form` dos rádios. Nesse caso, limita a busca
    // ao painel que contém o formulário acionado antes de usar qualquer fallback global.
    if (groups.size === 0) {
      const panel = form.closest('.pdp-mobile-info, .pdp-info-card, .product-detail__information');
      panel?.querySelectorAll('input[type="radio"]').forEach((input) => {
        if (!groups.has(input.name)) groups.set(input.name, []);
        groups.get(input.name).push(input);
      });
    }

    return [...groups.entries()].map(([name, inputs], index) => {
      const selected = inputs.find((input) => input.checked);
      return {
        name: name || productOptionNames[index] || '',
        // O ID de variante do formulário é a fonte de verdade, inclusive quando o tema
        // mantém os rádios desktop e mobile no DOM ao mesmo tempo.
        value: variantOptions[index] || selected?.value?.trim() || '',
        index,
      };
    });
  }

  isColorValue(value) {
    return ['preto', 'branco', 'azul', 'vermelho', 'verde', 'amarelo', 'rosa', 'roxo', 'laranja', 'marrom', 'cinza', 'bege', 'dourado', 'prata']
      .some((color) => value.toLowerCase().includes(color));
  }

  isSizeValue(value) {
    return /^(pp|p|m|g|gg|xg|xxg|xxxg|u|\d+[a-z]*)$/i.test(value.trim());
  }

  showModal() {
    this.updateVariantInfo();
    this.confirmarBtn.disabled = false;
    this.confirmarBtn.textContent = 'Confirmar compra';
    this.modal.style.display = 'flex';
    this.modal.offsetHeight;
    this.modal.classList.add('show');
    document.body.style.overflow = 'hidden';
  }

  hideModal() {
    this.modal?.classList.remove('show');
    window.setTimeout(() => {
      if (!this.modal?.classList.contains('show')) this.modal.style.display = 'none';
      document.body.style.overflow = '';
    }, 300);
  }

  confirmarCompra() {
    if (!this.formOriginal) return this.hideModal();

    const originalText = this.confirmarBtn.textContent;
    this.confirmarBtn.textContent = 'Adicionando...';
    this.confirmarBtn.disabled = true;

    try {
      this.formOriginal.requestSubmit(this.submitBtnOriginal || undefined);
      this.hideModal();
    } catch (_) {
      this.confirmarBtn.textContent = originalText;
      this.confirmarBtn.disabled = false;
    }
  }
}

new ConfirmacaoModal();
